<div class="summary-container">
  <!-- Summary Heading -->
  <h2 class="summary-heading" data-testid="summary-heading">Summary</h2>

  <!-- Contact Information Section -->
  <div class="summary-section" data-testid="summary-contact-section">
    <h3 class="section-title">Contact Information</h3>
    <div class="contact-grid">
      <div class="contact-field">
        <span class="field-label">AR Number</span>
        <span class="field-value" data-testid="summary-ar-number">{{
          contactData?.arNumber || '-'
        }}</span>
      </div>
      <div class="contact-field">
        <span class="field-label">Company Name</span>
        <span class="field-value" data-testid="summary-company-name">{{
          contactData?.companyName || '-'
        }}</span>
      </div>
      <div class="contact-field">
        <span class="field-label">First Name</span>
        <span class="field-value" data-testid="summary-first-name">{{
          contactData?.firstName || '-'
        }}</span>
      </div>
      <div class="contact-field">
        <span class="field-label">Last Name</span>
        <span class="field-value" data-testid="summary-last-name">{{
          contactData?.lastName || '-'
        }}</span>
      </div>
      <div class="contact-field">
        <span class="field-label">Phone</span>
        <span class="field-value" data-testid="summary-phone">{{
          contactData?.phoneNumber || '-'
        }}</span>
      </div>
      <div class="contact-field">
        <span class="field-label">Email</span>
        <span class="field-value" data-testid="summary-email">{{
          contactData?.email || '-'
        }}</span>
      </div>
    </div>
  </div>

  <!-- Expedite Request Section -->
  <div class="summary-section" data-testid="summary-expedite-section">
    <h3 class="section-title">Expedite Request</h3>
    <div class="expedite-info">
      <span class="field-label">Expedited Processing</span>
      <span class="field-value" data-testid="summary-expedite-value">{{
        isExpedited ? 'Yes' : 'No'
      }}</span>
      @if (isExpedited) {
        <span class="expedite-fee" data-testid="summary-expedite-fee">
          Fee: {{ expediteFee | currency: 'USD' : 'symbol' : '1.2-2' }}
        </span>
      }
    </div>
  </div>

  <!-- Files Grid Section -->
  <div class="summary-section" data-testid="summary-files-section">
    <h3 class="section-title">Uploaded Files</h3>

    <!-- No files message -->
    @if (parsedFiles.length === 0) {
      <div class="no-files-message">No files uploaded</div>
    }

    <!-- Files Grid -->
    @if (parsedFiles.length > 0) {
      <table class="files-grid" data-testid="summary-files-grid">
        <thead>
          <tr>
            <th>Filename</th>
            <th class="numeric">Check Count</th>
            <th class="numeric">DDA Count</th>
            <th class="numeric">Docs in File</th>
            <th class="numeric">Total $ Amount</th>
          </tr>
        </thead>
        <tbody>
          @for (file of parsedFiles; track file.fileId) {
            <tr>
              <td>{{ file.fileName }}</td>
              <td class="numeric">{{ file.checkCount }}</td>
              <td class="numeric">{{ file.ddaCount }}</td>
              <td class="numeric">{{ file.docsInFile }}</td>
              <td class="numeric">
                {{ file.totalAmount | currency: 'USD' : 'symbol' : '1.2-2' }}
              </td>
            </tr>
          }
        </tbody>
        <tfoot>
          <tr class="totals-row" data-testid="summary-files-total-row">
            <td><strong>Totals</strong></td>
            <td class="numeric">
              <strong>{{ fileTotals?.totalCheckCount || 0 }}</strong>
            </td>
            <td class="numeric">
              <strong>{{ fileTotals?.totalDdaCount || 0 }}</strong>
            </td>
            <td class="numeric">
              <strong>{{ fileTotals?.totalDocsInFile || 0 }}</strong>
            </td>
            <td class="numeric">
              <strong>{{
                fileTotals?.totalAmount || 0
                  | currency: 'USD' : 'symbol' : '1.2-2'
              }}</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    }
  </div>

  <!-- Review Note Section -->
  <div class="review-note" data-testid="summary-review-note">
    <p>{{ reviewNote }}</p>
  </div>
</div>
